import { useQuery } from 'react-query';

import { getCreateVsFixEncPerMonthChart } from 'api/analitics/EncCharts/getCreateVsFixEncPerMonthChart';

export const useGetCreatedVsFixedPerMonthChart = (slug: string, start_date: string, end_date: string) => {
  return useQuery(['createdVsFixedPerMonthChart', slug, start_date, end_date], () =>
    getCreateVsFixEncPerMonthChart(slug, start_date, end_date),
  );
};
